package com.demo.portfolio_demo.components.model

data class WorkExperience(
    val sequenceNumber: String,
    val role: String,
    val organization: String,
    val duration: String
)
